import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Dividend } from 'src/app/core/models/dividend';
import { Link } from 'src/app/core/models/link';
import { Page } from 'src/app/core/models/page';
import { SortData } from 'src/app/core/models/sort-data';
import { LinkService } from 'src/app/core/services/link.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-detail',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit ,OnDestroy{
  domainURL=environment.domain+"/"+(this.localId+"").substring(0,2)+"/";
  toYear=(new Date()).getFullYear();
  dividends: Dividend[];
  dividendLast: Dividend;
  linkList: Link[];
  page = new Page();
  sorts=new Array();
  isBrowser:any;
  commentCount: any;
  title: string;
  rootId: string;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(LOCALE_ID) private localId: Object,
    @Inject(PLATFORM_ID) private platformId: Object,
    public translate: TranslateService,
    public router: Router,
    private route: ActivatedRoute,
    private linkService: LinkService,

  ) { }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.isBrowser=isPlatformBrowser(this.platformId)
    this.route.data.subscribe(data => {
      this.dividends=data.dividendDetailResolver?.data;
      this.dividendLast=data.dividendDetailResolver?.data[0];
      this.commentCount=this.dividendLast?.commentCount;
      this.title=this.dividendLast.code+' Hisse Yorumları '+(this.dividendLast?.commentCount?'('+this.dividendLast?.commentCount+')':'');
      this.rootId="dividend-"+this.dividendLast?.url;
      this.getLink(this.dividendLast?.code);
    })
  }

  getLink(code:string) {
    let sortData=new SortData<Link>();
    let link = new Link();
    link.lang="tr";
    link.country="tr";
    link.code=code;
    sortData.filter=link;
    sortData.sorts=[{"dir": "desc", "prop": "createDate"}];
    this.page.pageNumber = 0;
    this.page.size = 5;
    this.linkService.getPageAbleList(this.page,sortData).pipe(takeUntil(this.destroy$)).subscribe({next: pagedData => {
      this.page = pagedData.page;
      this.page.pageNumber = this.page.pageNumber-1;
      this.linkList = pagedData.data;
    },
    error: error => {
      console.log("error: ",error);
    }});
  }

  public trackByFnLink(index, item) {
    if (!item) return null;
    return item.id;
  }

  public trackByFnDividend(index, item) {
    if (!item) return null;
    return item.id;
  }
}
